<template>
  <footer class="VB_Brochure_Footer">
    <p v-if="disclaimer">{{ disclaimer }}</p>
    <p>
      &copy; {{ copyright }} Swarm Interactive.
      {{ $t("warning") || "Unauthorized duplication is strictly forbidden." }}
    </p>
  </footer>
</template>

<script>
export default {
  name: "ViewmedicaBrochureFooter",

  computed: {
    disclaimer() {
      return this.$store.getters.disclaimer;
    },

    copyright() {
      return this.$store.getters.copyright;
    },
  },
};
</script>

<style lang="scss">
.VB_Brochure_Footer {
  position: absolute;
  right: 24pt;
  width: 208pt;
  font-family: helvetica, arial, sans-serif;
  font-size: 7pt;
  line-height: 1.3;
  bottom: 12pt;
}

.VB_Brochure_Footer p {
  margin: 10px 0 0 0;
}
</style>
